import { types, actions } from './requests'
export const DELETEDOCUMENT_TYPES = {
    ...types('DELETEDOCUMENT'),
}
export const DELETEDOCUMENT_ACTIONS = {
    ...actions('DELETEDOCUMENT'),
}
